import { useCallback, useEffect, useRef } from "react";

export const useBreakpoint = (breakpoint: number, callback: (eqAbove: boolean) => void): void => {
    const state = useRef(false);

    const handleResize = useCallback(() => {
        if (typeof window === "undefined") {
            return;
        }

        const width = window.innerWidth;

        const aboveBreakpoint = width >= breakpoint;

        state.current = aboveBreakpoint;

        callback(aboveBreakpoint);
    }, [breakpoint, state, callback]);

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }

        handleResize();

        window.addEventListener("resize", handleResize, { passive: true });

        return () => window.removeEventListener("resize", handleResize);
    }, [handleResize]);
};